module.exports = __webpack_public_path__ + "static/media/video.ab1d0698.mp4";